// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content_wrapper__34yjo","gc":"Content_gc__2yMQ1","controls":"Content_controls__2n-W4"};